module.exports = __webpack_public_path__ + "static/media/Wechat.33235d83.png";